import React from 'react';
import { Helmet } from 'react-helmet-async';

const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Rizzahra",
    "alternateName": "Rizzahra Abaya Store",
    "url": "https://rizzahra.store",
    "logo": "https://firebasestorage.googleapis.com/v0/b/rizzahra-43273.firebasestorage.app/o/74e4297d-1681-4176-a129-faaf9c90eaec-removebg-preview.png?alt=media&token=cd033554-61ba-4194-aacf-06fc9f7b4eb0",
    "description": "Premium modest fashion and modern abayas since 2025. Quality Islamic clothing and contemporary designs for the modern woman.",
    "foundingDate": "2025",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+923242146893",
      "contactType": "Customer Service",
      "areaServed": "PK",
      "availableLanguage": ["English", "Urdu"]
    },
    "sameAs": [
      // Add your social media URLs here
      // "https://www.facebook.com/rizzahra",
      // "https://www.instagram.com/rizzahra",
      // "https://www.twitter.com/rizzahra"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default OrganizationSchema;
